/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Field used to sort webhook event logs
 */
export type WebhookEventLogSortField = 'createdAt' | 'eventId' | 'id' | 'webhookSettingsId' | 'attemptNumber';

export const WebhookEventLogSortField = {
    CreatedAt: 'createdAt' as WebhookEventLogSortField,
    EventId: 'eventId' as WebhookEventLogSortField,
    Id: 'id' as WebhookEventLogSortField,
    WebhookSettingsId: 'webhookSettingsId' as WebhookEventLogSortField,
    AttemptNumber: 'attemptNumber' as WebhookEventLogSortField
};